(() => {
  const selector = 'details[data-scroll-lock-menu="brands"]';
  const lockClass = 'pt-brand-menu-open';
  const desktopQuery = window.matchMedia('(min-width: 990px)');

  const unlockPage = () => {
    document.documentElement.classList.remove(lockClass);
    document.body.classList.remove(lockClass);
    document.documentElement.style.removeProperty('--pt-brand-scrollbar-width');
  };

  const syncPageLock = () => {
    const brandMenuIsOpen =
      desktopQuery.matches && Array.from(document.querySelectorAll(selector)).some((menu) => menu.open);

    if (!brandMenuIsOpen) {
      unlockPage();
      return;
    }

    if (document.documentElement.classList.contains(lockClass)) return;
    const scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    document.documentElement.style.setProperty('--pt-brand-scrollbar-width', `${scrollbarWidth}px`);
    document.documentElement.classList.add(lockClass);
    document.body.classList.add(lockClass);
  };

  const bindBrandMenus = (scope = document) => {
    scope.querySelectorAll(selector).forEach((menu) => {
      if (menu.dataset.scrollLockBound === 'true') return;

      menu.dataset.scrollLockBound = 'true';
      menu.addEventListener('toggle', syncPageLock);
    });

    syncPageLock();
  };

  bindBrandMenus();
  desktopQuery.addEventListener('change', syncPageLock);
  document.addEventListener('shopify:section:load', (event) => bindBrandMenus(event.target));
  document.addEventListener('shopify:section:unload', syncPageLock);
  window.addEventListener('pagehide', unlockPage);
})();
